import { render } from "./FAQs.vue?vue&type=template&id=4abaae32&scoped=true&lang=html"
import script from "./FAQs.vue?vue&type=script&lang=js"
export * from "./FAQs.vue?vue&type=script&lang=js"

import "./FAQs.vue?vue&type=style&index=0&id=4abaae32&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4abaae32"]])

export default __exports__